import React, { useMemo } from 'react'
import { IconSelectListAdd, IconSelectListReadonly, IconSelectListRemove } from '../../../../../../../shared/icon/icon'

// A readonly item is always part of the selection and can't be removed: it is
// shown checked, greyed and disabled, with an optional hint (e.g. the auto
// roles every member gets: "Always included").
export const SelectListItem = ({ selectedItems, readonlyItems, readonlyHint, item, fnListFormat, onAdd, onRemove }) => {
  const isSelected = useMemo(() => !!selectedItems.find(selectedItem => selectedItem.id === item.id), [item, selectedItems])
  const isReadonly = useMemo(() => !!readonlyItems.find(readonlyItem => readonlyItem.id === item.id), [item, readonlyItems])

  const handleClick = () => {
    if (isReadonly) {
      return
    }

    if (isSelected) onRemove(item)
    else onAdd(item)
  }

  const hint = typeof readonlyHint === 'function' ? readonlyHint(item) : readonlyHint

  if (isReadonly) {
    return (
      <div className="d-flex align-items-center text-body-secondary" style={{ cursor: 'not-allowed', opacity: 0.65 }} aria-disabled="true" data-testid="select-list-readonly">
        <div className="border rounded p-1 m-1 bg-secondary text-white">
          <IconSelectListReadonly />
        </div>
        <div className="border-bottom p-1 m-1 flex-fill d-flex align-items-center">
          <span className="flex-fill">
            {fnListFormat(item)}
          </span>
          {hint &&
            <small className="ms-2 fst-italic">
              {hint}
            </small>}
        </div>
      </div>
    )
  }

  return (
    <div className="d-flex" style={{ cursor: 'pointer' }} onClick={handleClick}>
      <div className={`border rounded p-1 m-1 ${isSelected && 'bg-primary text-white'}`}>
        {isSelected ? <IconSelectListAdd /> : <IconSelectListRemove />}
      </div>
      <div className="border-bottom p-1 m-1 flex-fill">
        {fnListFormat(item)}
      </div>
    </div>
  )
}
